export function getFormatedPrice(val:number):string {
    return val.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
}


// WEBPACK FOOTER //
// ./src/utils/PricingUtils.ts